/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import {
  getBraindateId,
  isBraindateCancelled,
} from '@braindate/domain/lib/braindate/util';

import CheckInButtonDumb from './CheckInButtonDumb';
import { trackGAEvent } from 'src/shared/core/service/tracking/gaService';
import { getSelf } from 'src/shared/domain/user/selector/userSelectors';
import type { Braindate } from '@braindate/domain/lib/braindate/type';
import {
  hasOtherRescheduledBraindate,
  isBraindateCheckInReady,
} from 'src/shared/domain/braindate/util/braindateUtil';
import { checkInBraindate } from 'src/shared/app/check-in/action/checkInActions';
import { isCheckInIsFetching } from 'src/shared/app/check-in/selector/uiCheckInSelector';

type Props = {
  braindate: Braindate,
};

const mapStateToProps = (
  state: Object,
  { braindate, ...props }: Props,
): Object => ({
  ...props,
  braindate,
  selfUser: getSelf(state),
  isBraindateCheckInReady: isBraindateCheckInReady(braindate),
  isFetching: isCheckInIsFetching(state, { id: getBraindateId(braindate) }),
});

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (
  stateProps: Object,
  { dispatch }: Object,
  ownProps: Props,
): Object => {
  const { braindate } = ownProps;

  return {
    ...stateProps,
    Click() {
      if (
        isBraindateCheckInReady(braindate) &&
        !isBraindateCancelled(braindate) &&
        !hasOtherRescheduledBraindate(braindate, stateProps.selfUser)
      ) {
        trackGAEvent('Self check-in', 'Check in', 'Take over notification');

        dispatch(checkInBraindate(braindate));
      }
    },
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(CheckInButtonDumb);
